export default "__VITE_ASSET__BPBqar_n__"